<template>
  <div>
    <div @click="closeModal" v-if="modal" class="modal">
      <div class="modal-wrap" v-for="doc in modalContent" v-bind:key="doc.name">
        <div class="modal-content">
          <h2>{{ doc.name }}</h2>
          <div>
            <p>File Type:</p>
            <i
              v-if="doc.type === 'application/pdf'"
              class="fad fa-file-pdf"
            ></i>
            <i
              v-else-if="
                doc.type ===
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
              "
              class="fad fa-file-word"
            ></i>
            <i
              v-else-if="doc.type === 'application/csv'"
              class="fad fa-file-csv"
            ></i>
            <i v-else class="fad fa-globe"></i>
          </div>
        </div>
        <div class="modal-content">
          <h4>{{ doc.categoryName }}</h4>
          <p>Uploaded on: {{ doc.date.toDateString() }}</p>
        </div>
        <div class="modal-content">
          <a v-if="doc.url" :href="doc.url" class="btn">
            <i class="fad fa-download"></i>
          </a>
          <p>Uploaded by: {{ doc.createdby }}</p>
        </div>
        <div v-if="doc.docSummary" class="modal-content">
          <h4>Document Summary:</h4>
          <p>{{ doc.docSummary }}</p>
        </div>
        <div v-if="doc.docLinks" class="modal-content">
          <h4>Links:</h4>
          <a :href="doc.docLinks">{{ doc.docLinks }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CreateCategory",
  props: ["modal", "modalContent"],
  data() {
    return {};
  },
  methods: {
    // When clicked outside of the modal, this calls
    // and emit to be passed to the component
    // "ViewCategories" and closes the modal
    closeModal(e) {
      // sends a signal if the target clicked is not the modal wrap
      const modal = document.querySelector(".modal");
      if (e.target === modal) {
        this.$emit("close-modal");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.modal {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  background-color: rgba(0, 0, 0, 0.479);
  top: 0;
  left: 0;
  z-index: 99;
  height: 100%;
  width: 100%;

  .modal-wrap {
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    width: 600px;
    min-height: 200px;
    padding: 2rem;
    background-color: white;
  }

  .modal-content {
    align-items: center;
    padding: 4px 0;
    display: flex;
    flex-direction: row;

    div {
      justify-content: flex-end;
      display: flex;
      flex-direction: row;

      p {
        margin-right: 4px;
      }

      i {
        color: #6236ff;
      }
    }

    p {
      font-weight: 300;
      font-size: 14px;
    }

    & > * {
      display: flex;
      flex-direction: column;
      flex: 1;

      &:last-child {
        align-items: flex-end;
      }
    }

    &:nth-child(4) {
      align-items: flex-start;
      flex-direction: column;
      margin-top: 40px;

      h4 {
        margin-bottom: 8px;
      }
    }

    &:nth-child(5) {
      margin-top: 24px;
      flex-direction: column;
      align-items: flex-start;

      a {
        font-size: 14px;
        text-decoration: none;
      }
    }

    .btn {
      text-decoration: none;
      font-size: 14px;
      padding: 4px 4px;
    }
  }
}
</style>